import { Transition } from '@uirouter/angularjs';

export const UserConfirmationResolve = {
	token($transition$: Transition): string {
		'ngInject';

		return $transition$.params().token;
	}
};
